import { render, staticRenderFns } from "./PriceCalculate.vue?vue&type=template&id=524e7ee5"
import script from "./PriceCalculate.vue?vue&type=script&lang=js"
export * from "./PriceCalculate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports